"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardActionsViewController = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const WizardActions_1 = require("../../components/WizardActions/WizardActions");
class WizardActionsViewController extends core_1.ReactViewController {
    createElement(_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var { loading, pending } = _a, actions = __rest(_a, ["loading", "pending"]);
        return (react_1.default.createElement(WizardActions_1.WizardActions, { loading: loading || pending, prev: {
                hidden: actions.prev.hidden,
                disabled: actions.prev.disabled,
                didSelect: this.listener && this.listener.didSelectPrev.bind(this.listener),
                title: (_b = actions.prev.title) !== null && _b !== void 0 ? _b : (_c = this.texts) === null || _c === void 0 ? void 0 : _c.actionPrev
            }, next: {
                hidden: actions.next.hidden,
                disabled: actions.next.disabled,
                didSelect: this.listener && this.listener.didSelectNext.bind(this.listener),
                title: (_d = actions.next.title) !== null && _d !== void 0 ? _d : (_e = this.texts) === null || _e === void 0 ? void 0 : _e.actionNext
            }, skip: {
                hidden: actions.skip.hidden,
                disabled: actions.skip.disabled,
                didSelect: this.listener && this.listener.didSelectSkip.bind(this.listener),
                title: (_f = actions.skip.title) !== null && _f !== void 0 ? _f : (_g = this.texts) === null || _g === void 0 ? void 0 : _g.actionSkip
            }, done: {
                hidden: actions.done.hidden,
                disabled: actions.done.disabled,
                didSelect: this.listener && this.listener.didSelectDone.bind(this.listener),
                title: (_h = actions.done.title) !== null && _h !== void 0 ? _h : (_j = this.texts) === null || _j === void 0 ? void 0 : _j.actionDone
            }, cancel: {
                hidden: actions.cancel.hidden,
                disabled: actions.cancel.disabled,
                didSelect: this.listener && this.listener.didSelectCancel.bind(this.listener),
                title: (_k = actions.cancel.title) !== null && _k !== void 0 ? _k : (_l = this.texts) === null || _l === void 0 ? void 0 : _l.actionCancel
            } }));
    }
    present(state) {
        this.setState(state);
    }
    presentPending({ loading, pending }) {
        const prevState = this.getState();
        if (prevState) {
            this.setState(Object.assign(Object.assign({}, prevState), { loading, pending }));
        }
    }
}
exports.WizardActionsViewController = WizardActionsViewController;
//# sourceMappingURL=WizardActionsViewController.js.map